import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { FaBars, FaTimes } from "react-icons/fa";
import "./UniversalHeader.css";

const UniversalHeader = ({ onToggleSidebar, isSidebarOpen }) => {
  const location = useLocation();
  const [userName, setUserName] = useState("Your Profile");

  // Fetch user from Firebase
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserName(user.displayName || "Your Profile");
      } else {
        setUserName("Your Profile");
      }
    });
    return () => unsubscribe();
  }, []);

  // Determine header content based on current route
  const getHeaderContent = () => {
    const path = location.pathname;
    
    if (path.startsWith('/games')) {
      return {
        title: 'Chibi Dash Games',
        subtitle: 'Choose your favorite game',
        action: 'Explore'
      };
    } else if (path.startsWith('/new-blog-home')) {
      return {
        title: 'Chibi Dash Blog',
        subtitle: 'Dive into great content',
        action: 'Stay Inspired'
      };
    } else if (path.startsWith('/animehub')) {
      return {
        title: 'Anime Hub',
        subtitle: 'Explore your favorite anime',
        action: 'Find Top Anime Picks'
      };
    } else if (path.startsWith('/manga-home')) {
      return {
        title: 'Manga Hub',
        subtitle: 'Discover amazing manga',
        action: 'Read More'
      };
    } else if (path.startsWith('/profile')) {
      return {
        title: 'Your Profile',
        subtitle: 'Manage your account settings',
        action: 'Welcome Back!'
      };
    } else if (path.startsWith('/the-news')) {
      return {
        title: 'Chibi News',
        subtitle: 'Stay updated',
        action: 'Latest Stories'
      };
    } else if (path.startsWith('/community')) {
      return {
        title: 'Community',
        subtitle: 'Connect with fans',
        action: 'Join Discussion'
      };
    } else {
      return {
        title: 'Welcome to Chibi Dash',
        subtitle: 'Explore your favorite sections',
        action: 'Discover More'
      };
    }
  };

  const headerContent = getHeaderContent();

  return (
    <header className="universal-header">
      <div className="universal-header-left">
        <button 
          className="hamburger-btn" 
          onClick={onToggleSidebar}
          aria-label="Toggle Menu"
        >
          {isSidebarOpen ? <FaTimes /> : <FaBars />}
        </button>
        <div className="header-text">
          <h1 className="universal-header-title">{headerContent.title}</h1>
          <p className="universal-header-subtitle">{headerContent.subtitle}</p>
        </div>
      </div>

      <div className="universal-header-right">
        <p className="universal-header-action">{headerContent.action}</p>
      </div>
    </header>
  );
};

export default UniversalHeader;
